import React from 'react';

const AsteriskSymbol = () => {
  return <span className="asteriskPolicy">*</span>;
};

export default AsteriskSymbol;
